import { Box, TextField, Typography } from "@mui/material";
import { SASInputStyles } from "../ui/styles/inputStyles";
import { colors } from "../ui/colors";

export const TextFieldComponent = ({
  name,
  label,
  inputLabel,
  register,
  errors,
  type = "text",
  disabled = false,
}) => {
  const fieldError = errors?.[name];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.gray[600],
          fontWeight: 600,
          letterSpacing: 0.5,
          mb: 0.5
        }}
      >
        {label}
      </Typography>
      <TextField
        disabled={disabled}
        type={type}
        {...register}
        placeholder={inputLabel || label}
        variant="outlined"
        error={!!fieldError}
        sx={{
          ...SASInputStyles,
          width: "100%",
          mt: 0.5,
          mb: 0.5,
          borderWidth: "0.5px",
          "& .MuiOutlinedInput-root": {
            ...SASInputStyles["& .MuiOutlinedInput-root"],
            borderRadius: "14px",
          },
        }}
      />

      {fieldError && (
        <Typography color={colors.danger[600]} variant="caption">
          {fieldError.message}
        </Typography>
      )}
    </Box>
  );
};
